import instanceNew from "services/instance-new";
import store from "../../../redux/store";
import * as common from '../../../services/commonServices';
import * as retail from "../../../services/motorRetailService";


export const getCustomerDetails = (data, businessLine) => {

  return retail.getCustomerDetails(data, businessLine, {
        headers: {
          tawuniyalead: store?.getState()?.motor?.tawnLead,
        },
      });
};

export const getVehicleDetails = (data, businessLine) => {
  return retail.getVehicleDetails(data, businessLine,{
    headers: {
      tawuniyalead: store?.getState()?.motor?.tawnLead,
    },
  });
};

export const getDefaultValues = async (request, businessLine) => {
  request.channelDetails={
    applicationCategory: "RH",
    applicationType: "RHSP",
    branchCode: "85",
    channelCode: "85",
    sourceCode: "755897",
    userName: "FRS2050001",
  };
  return retail.getDefaultValues(request, businessLine,{
    headers: {
      tawuniyalead: store?.getState()?.motor?.tawnLead,
    },
  });
}


export const getProposal = async (data, productCode, businessLine) => {
  return retail.getProposal(data, productCode, businessLine,{
    headers: {
      tawuniyalead: store?.getState()?.motor?.tawnLead,
    },
  });
}

export const getQuotationDetails = async (data, productCode) => {
  return retail.getQuotationDetails(data, productCode,{
    headers: {
      tawuniyalead: store?.getState()?.motor?.tawnLead,
    },
  });
}


export const sendOTP = async (MOBILE, id) => {
  const mobile = MOBILE;
  return common.sendOTPwithFlag(mobile, "MOTOR", id);
};

export const verifyOTP = async (mobile, otp, id, isInternal) => {
  return common.validateOTPWithFlag(mobile, otp, id, isInternal);
};

export const createQuotation = async (data, businessLine) => {
  return retail.createQuotation(data, businessLine,{
    headers: {
      tawuniyalead: store?.getState()?.motor?.tawnLead,
    },
  });
}

export const updateQuotation = async (data, businessLine) => {
  return retail.updateQuotation(data, businessLine,{
    headers: {
      tawuniyalead: store?.getState()?.motor?.tawnLead,
    },
  });
}

export const getPromotionDetails = async (reqData) => {
  try {
    const { data } = await instanceNew.post('/common/promotion', reqData,{
      headers: {
        tawuniyalead: store?.getState()?.motor?.tawnLead,
      },
    })
    if (data && data.resultCode === 'S') return data
    else Promise.reject(data.resultMessage)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const smsPromotion = async (reqData) => {
  // 
  try {
    const { data } = await instanceNew.post('elm/motorRetail/smsPromotion', reqData,{
      headers: {
        tawuniyalead: store?.getState()?.motor?.tawnLead,
      },
    })
    // 
    if (data && data.resultCode === 'S') return data
    else Promise.reject(data.resultMessage)
  } catch (error) {
    return Promise.reject(error)
  }
}




// export const getStandardDeductables = async (reqData) => {
//   reqData['channelDetails'] = {
//     "applicationCategory": "RH",
//     "applicationType": "RHSP",
//     "branchCode": "1",
//     "channelCode": "85",
//     "sourceCode": "550541",
//     "userName": "EBUSUSER"
//   }
//   reqData['deductibleCode'] = ''
//   try {
//     const { data } = await instanceNew.post('/motorRetail/getStandardDeductible', reqData)
//   } catch (error) {

//   }
// }
